<!--
 * @Author: your name
 * @Date: 2020-08-28 19:15:26
 * @LastEditTime: 2020-09-17 11:07:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\contractProgress\overDelivery.vue
-->
<template>
    <div class="overDelivery">
        <van-nav-bar
            title="超限发货"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <section>
            <header>
                <div class="headerContent">
                    <div class="head">
                        <h3>{{ detail.client_name }}</h3>
                        <p>{{ detail.engineering_name }}</p>
                    </div>
                    <van-divider></van-divider>
                    <div class="progress-wrapper">
                        <div class="progress-content">
                            <p :style="progressWidthObj()" :class="{'red':Number(progressWidth)>=100}"></p>
                            <span
                                :style="leftObj()"
                            >{{ progressNum }}%</span>
                        </div>
                    </div>
                    <div class="sort">
                        <div class="Arrears">
                            <h5 class="iconfont iconjine">
                                超限申请额度:
                            </h5>
                            <p>{{ detail.transfinite_apply_total_money }}万</p>
                        </div>
                        <div class="Paid">
                            <h5 class="iconfont iconjine">
                                发货超限额度:
                            </h5>
                            <p>{{ detail.transfinite_use_total_money }}万</p>
                        </div>
                    </div>
                    <div class="sort">
                        <div class="Arrears">
                            <h5 class="iconfont iconjine">
                                订单超限额度:
                            </h5>
                            <p>{{ detail.order_total_money }}万</p>
                        </div>
                        <div class="Paid">
                            <h5 class="iconfont iconjine">
                                可用超限额度:
                            </h5>
                            <p>{{ detail.can_use_total_money }}万</p>
                        </div>
                    </div>
                </div>
            </header>

            <div class="list-wrapper">
                <div
                    class="list-item"
                    v-for="item in list"
                    :key="item.ctsid"
                >
                    <div class="row">
                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                        <span>超发起始时间：{{ item.takeeffect_start_time }}</span>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                        <span>超发终止时间：{{ item.takeeffect_end_time }}</span>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                        <span>超限发货方式：</span>
                        <span>{{ item.overrun_despatch_mode_message }}</span>
                        <!-- <span v-if="item.overrun_despatch_mode === 1">按金额</span>
                        <span v-else-if="item.overrun_despatch_mode === 2">按方量</span>
                        <span v-else-if="item.overrun_despatch_mode === 3">按时间</span> -->
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_30.png" alt="">
                        <span>超限申请额度：{{ item.overrun_despatch_money }}万元</span>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_30.png" alt="">
                        <span>发货占用额度：{{ item.delivery_total_money }}万元</span>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_30.png" alt="">
                        <span>订单占用额度：{{ item.order_total_money }}万元</span>
                    </div>
                    <div class="row">
                        <img src="@/assets/images/icons/icon_30.png" alt="">
                        <span>可用超限额度：{{ item.available_amount }}万元</span>
                    </div>
                    <div class="invalid" v-if="item.takeeffect_end_time"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            progressWidth: 0,
            progressNum: 0,
            detail: {},
            list: [],
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const detail = JSON.parse(JSON.stringify(this.$route.params.obj));
            // detail.transfinite_apply_total_money = 20000;
            if (detail.transfinite_apply_total_money ) {
                if (Number(detail.transfinite_apply_total_money) !== 0) {
                    this.progressNum = (Number(detail.transfinite_use_total_money) / Number(detail.transfinite_apply_total_money) * 100).toFixed(2);
                    this.progressWidth = (Number(detail.transfinite_use_total_money) / Number(detail.transfinite_apply_total_money) * 100).toFixed(2);
                    if (Number(this.progressWidth) > 100) {
                        this.progressWidth = 100;
                    }
                }
            }
            detail.transfinite_apply_total_money = (Number(detail.transfinite_apply_total_money) / 10000).toFixed(2);
            detail.transfinite_use_total_money = (Number(detail.transfinite_use_total_money) / 10000).toFixed(2);

            this.detail = detail;
            this.getList();
        },
        leftObj() {
            let str = '';
            if (Number(this.progressWidth) < 10) {
                str = { left: `${this.progressWidth}%` };
            } else {
                str = { left: `calc(${this.progressWidth}% - 26px)` };
            }
            return str;
        },
        progressWidthObj() {
            let str = { width: `${this.progressWidth}%` };
            if (Number(this.progressWidth) > 0) {
                str = { width: `calc(${this.progressWidth}% - 4px)` };
            }
            return str;
        },
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        async getList() {
            const res = await this.getListApi();
            if (res) {
                const res2 = res.map(item => {
                    if (item.delivery_total_money) {
                        item.delivery_total_money = (item.delivery_total_money / 10000).toFixed(2);
                    }
                    if (item.order_total_money) {
                        item.order_total_money = (item.order_total_money / 10000).toFixed(2);
                    }
                    if (item.available_amount) {
                        item.available_amount = (item.available_amount / 10000).toFixed(2);
                    }
                    return item;
                });
                this.list = res2;

                let orderTotalMoney = 0.00;
                this.list.forEach(item => {
                    orderTotalMoney += Number(item.order_total_money);
                });
                this.$set(this.detail, 'order_total_money', orderTotalMoney);

                const diffMoney = this.detail.transfinite_use_total_money > this.detail.order_total_money
                    ? this.detail.transfinite_use_total_money : this.detail.order_total_money;
                const can_use_total_money = Number(this.detail.transfinite_apply_total_money - diffMoney).toFixed(2);

                this.$set(this.detail, 'can_use_total_money', can_use_total_money);

            }
        },
        getListApi() {
            const path = '/interfaceApi/sale/contract_transfinite/get_list_contract?contractNumber=' + this.detail.contract_number;
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.overDelivery
    height 100%
    section
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        background #F0F0F0
        display flex
        flex-direction column
        header
            // height 150rpx
            background #2b5dab
            padding 15rpx
            .headerContent
                height 100%
                background 100%
                background #fff
                border-radius 4rpx
                .head
                    padding 14rpx
                    h3
                        font-size 16rpx
                        color #333333
                        margin-bottom 10rpx
                    p
                        font-size 14rpx
                        color #979EA7
                .van-divider
                    margin 0
                .progress-wrapper
                    padding 25rpx 10rpx 10rpx 10rpx
                    .progress-content
                        height 18rpx
                        background rgba(254,247,235,1)
                        border 2px solid rgba(250,132,54,1)
                        border-radius 10px
                        // overflow hidden
                        position relative
                        p
                            height 10rpx
                            background #3495FB
                            border-radius 10rpx
                            margin-top 2rpx
                            margin-left 2rpx
                            transition all 2s
                            &.red
                                background #E60000
                        span
                            background #3495FB
                            padding 0 2rpx
                            height 20rpx
                            color #ffffff
                            position absolute
                            top -25rpx
                            // left calc(58% - 15rpx)
                            font-size 12rpx
                            border-radius 4rpx
                            text-align center
                            line-height 20rpx
                            &::after
                                content ""
                                width 0
                                height 0
                                border 4rpx solid
                                border-color #3495FB transparent  transparent  transparent
                                position absolute
                                left 50%
                                margin-left -3rpx
                                bottom -8rpx
                .sort
                    overflow hidden
                    position relative
                    &:before
                        content ''
                        width 1px
                        height 15rpx
                        background #F0F0F0
                        position absolute
                        left 50%
                        top 50%
                        transform translateY(-50%)
                    div
                        float left
                        width 50%
                        padding-left 8rpx;
                        white-space nowrap
                        h5,p
                            display inline-block
                            line-height 40rpx
                            height 40rpx
                        h5
                            font-size 12rpx
                            color #979EA7
                            &:before
                                font-size 14rpx
                        p
                            font-size 14rpx

                            margin-left 5rpx
                        &.Paid
                            p
                                color #3495FB
                        &.Arrears
                            p
                                color #F15742
        .list-wrapper
            flex 1
            padding 15rpx 15rpx 0 15rpx
            .list-item
                padding 15rpx 15rpx 5rpx 15rpx
                background #ffffff
                border-radius 4rpx
                margin-bottom 15rpx
                position relative
                .row
                    line-height 16rpx
                    font-size 14rpx
                    margin-bottom 15rpx
                    color #666666
                    img
                        width 18rpx
                        height 18rpx
                        display inline-block
                        vertical-align middle
                        margin-right 5rpx
                .invalid
                    position absolute
                    right 10rpx
                    bottom 20rpx
                    width 60rpx
                    height 60rpx
                    background url(./../../../assets/images/contractInfo/icon_sx.png) no-repeat
                    background-size 100% 100%
</style>
